/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowstartwithpictures4Inputs */

const en_aiflowstartwithpictures4 = /** @type {(inputs: Aiflowstartwithpictures4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in from the pictures`)
};

const de_aiflowstartwithpictures4 = /** @type {(inputs: Aiflowstartwithpictures4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus den Bildern ausfüllen`)
};

/**
* | output |
* | --- |
* | "Fill in from the pictures" |
*
* @param {Aiflowstartwithpictures4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowstartwithpictures4 = /** @type {((inputs?: Aiflowstartwithpictures4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowstartwithpictures4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowstartwithpictures4(inputs)
	return de_aiflowstartwithpictures4(inputs)
});
export { aiflowstartwithpictures4 as "aiFlowStartWithPictures" }